import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';
import moment from 'moment';
import { validar } from "../../../common/components/components/ValidarNit";

const LISTADO_COMPRA = 'LISTADO_COMPRA';
const LISTADO_TIPOS_DOCU = 'LISTADO_TIPOS_DOCU';
const LISTADO_PROVEEDOR = 'LISTADO_PROVEEDOR';
const GUARDAR_LIQUIDACION = 'GUARDAR_LIQUIDACION';
const GUARDAR_POLIZA = 'GUARDAR_POLIZA';
const DETALLE_POLIZA = 'DETALLE_POLIZA';
const DETALLE_LIQUIDACION = 'DETALLE_LIQUIDACION';
const CONSULTA_FACTURA = 'CONSULTA_FACTURA';
const VER_FACTURA = 'VER_FACTURA';
const LOADER = 'LOADER';
const LOADERC = 'LOADERC';
const NIVEL = 'NIVEL';
const PERIODO_D = 'PERIODOD';
const MODULO = 'MODULO';
const PARAMETRO = 'PARAMETRO';
const LISTADO_PAISES = 'LISTADO_PAISES';
const LISTADO_IMPUESTO = 'LISTADO_IMPUESTO';
const PROVEEDOR = 'PROVEEDOR';
const TOTAL_LIQ = 'TOTAL_LIQ';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setLoaderC = loaderC => ({
    type: LOADERC,
    loaderC,
});

function actualizarLiquidacion(campo, valor) {
    try {
        let liquidacionBono = JSON.parse(sessionStorage.getItem('liquidacionBono'));
        
        // Si no existe, crear estructura base
        if (liquidacionBono === null || liquidacionBono === undefined || Object.keys(liquidacionBono || {}).length === 0) {
            liquidacionBono = {
                idPolizaCompraLiq: null, //id poliza
                dif: 0.00,
                cc: null
            };
        }
        
        // Actualizar el campo específico
        liquidacionBono[campo] = valor;
                
        sessionStorage.setItem('liquidacionBono', JSON.stringify(liquidacionBono));
        return liquidacionBono;
        
    } catch (error) {
        return null;
    }
}

function obtenerLiquidacion() {
    const stored = sessionStorage.getItem('liquidacionBono');
    return stored ? JSON.parse(stored) : null;
}


export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let id_period = id_emp[7];
    //const params = { page, id, id_period };
    const params = { id, id_period };
    dispatch(setLoader(true));
    api.get('/liquidacion_bono', params).then((response) => {
        dispatch({ type: LISTADO_COMPRA, data: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar compras',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const listarTiposDocu = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id };
    api.get('/tipos', params).then((response) => {
        const tiposD = [];
        response.results.forEach(item => {
            if (item.tipo_documento === 'CARGO') {
                tiposD.push({
                    value: item.id,
                    label: item.tipo + ' - ' + item.descripcion,
                    search: item.categoria
                })
            }
        })
        dispatch({ type: LISTADO_TIPOS_DOCU, tipos: tiposD });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar tipos de documento',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const listarProveedores = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let tipo = 'liquidacion';
    const params = { id, search, tipo }
    return api.get('/proveedor/empresa_proveedores', params).then(data => {
        const list_proveedor = [];
        if (data) {
            data.forEach(item => {
                list_proveedor.push({
                    value: item.id,
                    label: item.identificador + ' ' + item.nombre
                })
            })
        }
        return list_proveedor;
    }).catch((error) => {
        return [];
    })
}

export const listarCuentas = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id, search }
    return api.get('/cuentas/empresa_cuentas/', params).then(data => {
        const list_cuentas = [];
        if (data) {
            data.forEach(item => {
                if (item.tipo === 'A') {
                    list_cuentas.push({
                        value: item.id,
                        label: item.cuenta + ' ' + item.nombre,
                        isDisabled: true
                    })
                } else {
                    list_cuentas.push({
                        value: item.id,
                        label: item.cuenta + ' ' + item.nombre
                    })
                }
            })
        }
        return list_cuentas;
    }).catch((error) => {
        return [];
    })
}

export const listarCC = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id, search }
    return api.get('/centrocosto/empresa_centro_costo/', params).then(data => {
        const list_cc = [];
        if (data) {
            data.forEach(item => {
                list_cc.push({
                    value: item.id,
                    label: item.codigo + ' ' + item.descripcion
                })
            })
        }
        return list_cc;
    }).catch((error) => {
        return [];
    })
}

const leerDetalle = id => (dispatch) => {
    api.get(`/poliza_detalle/${id}`).then((response) => {
        dispatch({ type: DETALLE_POLIZA, detalle: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            2000
        );
    })
};

export const listarNiveles = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = { id };
    dispatch(setLoader(true));
    api.get('/niveles/nivel_cuenta', params).then((response) => {
        dispatch({ type: NIVEL, nivel: response });
    }).catch((error) => {

        NotificationManager.error(
            'Ocurrió un error al listar nivel',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const eliminarLinea = id => (dispatch) => {
    const liquidacion = obtenerLiquidacion();
    const poliza = liquidacion ? liquidacion.idPolizaCompraLiq : null;
    dispatch(setLoader(true));
    api.eliminar(`poliza_detalle/${id}`).then(() => {
        const editar = window.location.href.includes('editar');
        if (editar) {
            dispatch(leerDetalleMod(poliza));
        } else {
            dispatch(leerDetalle(poliza));
        }
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar linea de poliza',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const registroCuenta = (formato) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const data = getStore().form.LiquidacionBonosFormTabs.values;
    const liquidacion = obtenerLiquidacion();

    let cuenta = data.cuenta
    let f = formato.split('-');
    let cont = 0;
    let formatoCuenta = '';
    let digito = '';

    if (f.length === 3) {
        let nivel1 = f[0].length
        digito = cuenta.substr(cont, nivel1);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel2 = f[1].length;
        cont = cont + nivel1;
        digito = cuenta.substr(cont, nivel2);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel3 = f[2].length;
        cont = cont + nivel2;
        digito = cuenta.substr(cont, nivel3);
        formatoCuenta = formatoCuenta + digito;

    }

    if (f.length === 4) {
        let nivel1 = f[0].length
        digito = cuenta.substr(cont, nivel1);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel2 = f[1].length;
        cont = cont + nivel1;
        digito = cuenta.substr(cont, nivel2);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel3 = f[2].length;
        cont = cont + nivel2;
        digito = cuenta.substr(cont, nivel3);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel4 = f[3].length;
        cont = cont + nivel3;
        digito = cuenta.substr(cont, nivel4);
        formatoCuenta = formatoCuenta + digito;
    }

    if (f.length === 5) {
        let nivel1 = f[0].length
        digito = cuenta.substr(cont, nivel1);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel2 = f[1].length;
        cont = cont + nivel1;
        digito = cuenta.substr(cont, nivel2);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel3 = f[2].length;
        cont = cont + nivel2;
        digito = cuenta.substr(cont, nivel3);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel4 = f[3].length;
        cont = cont + nivel3;
        digito = cuenta.substr(cont, nivel4);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel5 = f[4].length;
        cont = cont + nivel4;
        digito = cuenta.substr(cont, nivel5);
        formatoCuenta = formatoCuenta + digito;
    }

    if (f.length === 6) {
        let nivel1 = f[0].length
        digito = cuenta.substr(cont, nivel1);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel2 = f[1].length;
        cont = cont + nivel1;
        digito = cuenta.substr(cont, nivel2);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel3 = f[2].length;
        cont = cont + nivel2;
        digito = cuenta.substr(cont, nivel3);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel4 = f[3].length;
        cont = cont + nivel3;
        digito = cuenta.substr(cont, nivel4);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel5 = f[4].length;
        cont = cont + nivel4;
        digito = cuenta.substr(cont, nivel5);
        formatoCuenta = formatoCuenta + digito + '-';

        let nivel6 = f[5].length;
        cont = cont + nivel5;
        digito = cuenta.substr(cont, nivel6);
        formatoCuenta = formatoCuenta + digito;
    }
    let idPoliza = liquidacion ? liquidacion.idPolizaCompraLiq : null;
    const formData = {
        cuenta: formatoCuenta,
        nombre: data.nombre,
        tipo: data.tipoC,
        naturaleza: data.naturaleza,
        empresa: id_emp[5],
        poliza: idPoliza
    }
    dispatch(setLoaderC(true));
    api.post('/cuentas/', formData).then((response) => {
        if (idPoliza) {
            NotificationManager.success(
                'Cuenta creada' + ' ' + response.cuenta.cuenta + ' ' + response.cuenta.nombre,
                'Exito',
                0
            );
            response.cuenta = '';
            response.nombre = '';
            response.fecha = response.poliza.fecha;
            response.tipo = response.poliza.tipo;
            response.numero_poliza = response.poliza.numero_poliza;
            response.descripcion = response.poliza.descripcion;
            listarCuentas();

        } else {
            NotificationManager.success(
                'Cuenta creada' + ' ' + response.cuenta + ' ' + response.nombre,
                'Exito',
                0
            );
            response.cuenta = '';
            response.nombre = '';
            listarCuentas();
        }

    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoaderC(false));
    });
}

export const reporteCuentas = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let reporte = 'reporte';
    const params = { id, reporte };
    dispatch(setLoaderC(true));;
    api.getPdf('/cuentas/', params).then((response) => {
        if (response.headers['content-type'] == 'application/pdf') {
            var blob = new Blob([response.text], { type: 'application/pdf;charset=utf-8' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'reporte_cuentas_contables.pdf';
            window.open(link, '_blank');
            return false;
        }
    }).catch((error) => {

        NotificationManager.error(
            'Ocurrió un error al generar reporte',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoaderC(false));
    });
}

export const registroCompra = (data={},attachments=[], periodoD, datos) => (dispatch, getStore) => {
    const data = getStore().form.FormLiquidacionBonos.values;
    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fechaRegistro);
    let poliza = '';
    if (fecha >= fechaI && fecha <= fechaF) {
        if (data.proveedor_liquidacion === undefined || data.proveedor_liquidacion === null) {
            Swal.fire({
                title: 'Liquidación de bonos',
                text: 'Debe de seleccionar proveedor',
                type: 'error',
            })
        } else {
            if (datos.contabilidad === 'S') {
                if (data.cuenta_debe === undefined || data.cuenta_debe === null) {
                    Swal.fire({
                        title: 'Liquidación de bonos',
                        text: 'Debe de seleccionar cuenta del debe',
                        type: 'error',
                    })
                } else {
                    if (data.cuenta_haber === undefined || data.cuenta_haber === null) {
                        Swal.fire({
                            title: 'Liquidación de bonos',
                            text: 'Debe de seleccionar cuenta del haber',
                            type: 'error',
                        })
                    } else {
                        let ruta = window.location.href;
                        let id_emp = ruta.split('/');
                        let fec = data.fechaRegistro;
                        let fecR = fec.split('-')
                        let serieL = fecR[0] + '-' + fecR[1]
                        const formData = {
                            fecha_registro: data.fechaRegistro,
                            serie: serieL,
                            numero: 1,
                            descripcionL: data.observaciones,
                            fecha: data.fecha,
                            periodo: id_emp[7],
                            proveedor_liq: data.proveedor_liquidacion.value,
                            modulo: 'CMP',
                            empresa: id_emp[5],
                            poliza: poliza,
                            cuenta_debe: datos.contabilidad === 'S' ? data.cuenta_debe.value : '',
                            cuenta_haber: datos.contabilidad === 'S' ? data.cuenta_haber.value : '',
                        }

                        dispatch(setLoader(true));
                        api.postAttachments('/liquidacion_bono/liquidaciones_bonos/', formData, attachments).then((response) => {
                            if (parseInt(response.errores) >= 1) {
                                NotificationManager.error(
                                    response.msj,
                                    'Error',
                                    0
                                );
                                api.getExcel('/liquidacion_bono/generar_excel/', formData).then((res) => {
                                    
                                    const blob = res;
                                    const fileName = 'errores_liquidacion_bonos' + '.xlsx';
                                    
                                    // Descargar el archivo utilizando la función saveAs de file-saver
                                    const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                                    saveAs(file, fileName);
                                    window.location.reload();
                                }).catch(error => {
                                    if (error === 404) {
                                        NotificationManager.error(
                                            "No se encontraron datos",
                                            'Informacion',
                                            5000
                                        );
                                    }
                                    if (error === 500) {
                                        NotificationManager.error(
                                            'Ocurrió un error al generar reporte',
                                            'Error',
                                            0
                                        );
                                    }
                                })
                            }else{
                                NotificationManager.success(
                                    'Compras creadas correctamente',
                                    'Exito',
                                    3000
                                );
                                dispatch({ type: PROVEEDOR, proveedor_liq: response.proveedorN });
                                dispatch({ type: TOTAL_LIQ, total_liq: response.total });
                                dispatch(leerDetalleLiquidacion(response.detalle));
                                actualizarLiquidacion('idPolizaCompraLiq', response.id_poliza);
                                dispatch(leerDetalle(response.id_poliza));
                            }
                        }).catch((error) => {
                            NotificationManager.error(
                                error.msj,
                                'Error',
                                0
                            );
                        }).finally(() => {
                            dispatch(setLoader(false));
                        });
                    }
                }
            } else {
                let ruta = window.location.href;
                let id_emp = ruta.split('/');
                let fec = data.fechaRegistro
                let fecR = fec.split('-')
                let serieL = fecR[0] + '-' + fecR[1]

                const formData = {
                    fecha_registro: data.fechaRegistro,
                    serie: serieL,
                    numero: 1,
                    descripcionL: data.observaciones,
                    periodo: id_emp[7],
                    proveedor_liq: data.proveedor_liquidacion.value,
                    modulo: 'CMP',
                    empresa: id_emp[5],
                    poliza: poliza,
                }

                dispatch(setLoader(true));
                api.postAttachments('/liquidacion_bono/liquidaciones_bonos/', formData, attachments).then((response) => {
                    NotificationManager.success(
                        'Compras creadas correctamente',
                        'Exito',
                        3000
                    );
                    response.totalLiq = response.total;
                    dispatch(leerDetalleLiquidacion(response.detalle));
                    dispatch(leerDetalle(response.id_poliza))
                }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        0
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    } else {
        Swal.fire({
            title: 'Liquidación de bonos',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

export const modificarCompra = (periodoD) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormLiquidacionBonos.values;
    let id = data.id;
    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fechaRegistro);
    if (fecha >= fechaI && fecha <= fechaF) {
        let pro = data.proveedor_liquidacion;
        if (pro === undefined) {
            pro = data.proveedor;
        } else {
            pro = data.proveedor_liquidacion.value;
        }
        const formData = {
            id: id,
            fecha_registro: data.fechaRegistro,
            serie: 'A',
            numero: 1,
            descripcionL: data.observaciones,
            proveedor_liq: pro,
        }

        dispatch(setLoader(true));
        api.put(`/liquidacion_bono/${id}/`, formData).then(() => {

            NotificationManager.success(
                'Liquidación de gastos modificada correctamente',
                'Exito',
                3000
            );
            ruta = `/compras/${id_emp[5]}/liquidacion_bonos/${id_emp[7]}`;
            dispatch(push(ruta));
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                3000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    } else {
        Swal.fire({
            title: 'Liquidación de gastos',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/liquidacion_bono/${id}`).then((response) => {
        response.observaciones = response.descripcion;
        response.fechaRegistro = response.fecha_registro;
        response.totalLiq = response.total;
        response.numeroL = response.numero;
        response.numero = '';
        response.descripcion = '';
        response.identificador = response.nit_proveedor;
        
        dispatch({ type: GUARDAR_LIQUIDACION, lecturaLq: response });
        dispatch(initializeForm('FormLiquidacionBonos', response));
        dispatch(leerDetalleLiquidacion(response.id));
        if (response.poliza) {
            actualizarLiquidacion('idPolizaCompraLiq', response.poliza);
            dispatch(leerDetalleMod(response.poliza));
        }
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar liquidación',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const listarProveedoresD = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let search = '';
    let tipo = 'liquidacion';
    const params = { id, search, tipo };
    dispatch(setLoader(true));
    return api.get('/proveedor/empresa_proveedores', params).then(data => {
        const list_proveedor = [];
        if (data) {
            data.forEach(item => {
                list_proveedor.push({
                    value: item.id,
                    label: item.nombre,
                    search: item.identificador
                })
            })
        }
        dispatch({ type: LISTADO_PROVEEDOR, prov: list_proveedor });
    }).catch((error) => {

        NotificationManager.error(
            'Ocurrió un error al listar proveedores',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroPolizaDetalle = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.LiquidacionBonosFormTabs.values;
    const liquidacion = obtenerLiquidacion();
    const poliza = liquidacion ? liquidacion.idPolizaCompraLiq : null;
    const formData = {
        empresa: id_emp[5],
        periodo: id_emp[7],
        cc: data.cc.value,
        cuenta: data.cuenta.value,
        debe: data.debe,
        haber: data.haber,
        poliza: poliza
    }
    if (formData.debe === undefined && formData.haber === undefined) {
        Swal.fire({
            title: 'Nueva poliza',
            text: 'Debe de ingresar valor en debe o haber',
            type: 'error',
        })
    } else if (parseFloat(formData.debe) === 0.00 && parseFloat(formData.haber) === 0.00) {
        Swal.fire({
            title: 'Nueva poliza',
            text: 'No puede llevar valores a 0.00 en debe o haber',
            type: 'error',
        })
    } else if (parseFloat(formData.debe) >= 0.01 && parseFloat(formData.haber) >= 0.01) {
        Swal.fire({
            title: 'Nueva poliza',
            text: 'No puede llevar valores en debe y haber',
            type: 'error',
        })
    } else if (parseFloat(formData.debe) >= 0.01) {
        formData.haber = 0.00;
        dispatch(setLoader(true));
        api.post('/polizas/encabezado_polizas/', formData).then((response) => {
            
            if (poliza === null) {
                response.debe = 0.00;
                response.haber = 0.00;
                dispatch(initializeForm('FormLiquidacionBonos', response));
                dispatch(leerDetalle(response.detalle.encabezado));
            } else {
                const editar = window.location.href.includes('editar');
                if (editar) {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalleMod(poliza));
                } else {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalle(poliza));
                }
            }
        }).catch((error) => {
            NotificationManager.error(
                'Ocurrió un error al registrar la poliza',
                'Error',
                2000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    } else if (parseFloat(formData.haber) >= 0.01) {
        formData.debe = 0.00;
        dispatch(setLoader(true));
        api.post('/polizas/encabezado_polizas/', formData).then((response) => {
            if (poliza === null) {
                response.debe = 0.00;
                response.haber = 0.00;
                dispatch(initializeForm('FormLiquidacionBonos', response));
                dispatch(leerDetalle(response.encabezado));
            } else {
                const editar = window.location.href.includes('editar');
                if (editar) {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalleMod(poliza));
                } else {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalle(poliza));
                }
            }

        }).catch((error) => {
            NotificationManager.error(
                'Ocurrió un error al registrar la poliza',
                'Error',
                0
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

export const registroPolizaDetalleSCC = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.LiquidacionBonosFormTabs.values;
    const liquidacion = obtenerLiquidacion();
    const poliza = liquidacion ? liquidacion.idPolizaCompraLiq : null;
                               
    const formData = {
        empresa: id_emp[5],
        periodo: id_emp[7],
        cc: 0,
        cuenta: data.cuenta.value,
        debe: data.debe,
        haber: data.haber,
        poliza: poliza
    }
    if (formData.debe === undefined && formData.haber === undefined) {
        Swal.fire({
            title: 'Nueva poliza',
            text: 'Debe de ingresar valor en debe o haber',
            type: 'error',
        })
    } else if (parseFloat(formData.debe) === 0.00 && parseFloat(formData.haber) === 0.00) {
        Swal.fire({
            title: 'Nueva poliza',
            text: 'No puede llevar valores a 0.00 en debe o haber',
            type: 'error',
        })
    } else if (parseFloat(formData.debe) >= 0.01 && parseFloat(formData.haber) >= 0.01) {
        Swal.fire({
            title: 'Nueva poliza',
            text: 'No puede llevar valores en debe y haber',
            type: 'error',
        })
    } else if (parseFloat(formData.debe) >= 0.01) {
        formData.haber = 0.00;
        dispatch(setLoader(true));
        api.post('/polizas/encabezado_polizas/', formData).then((response) => {
            if (poliza === null) {
                response.debe = 0.00;
                response.haber = 0.00;
                dispatch(initializeForm('FormLiquidacionBonos', response));
                dispatch(leerDetalle(response.detalle.encabezado));
            } else {
                const editar = window.location.href.includes('editar');
                if (editar) {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalleMod(poliza));
                } else {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalle(poliza));
                }
            }

        }).catch((error) => {
            NotificationManager.error(
                'Ocurrió un error al registrar la poliza',
                'Error',
                0
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    } else if (parseFloat(formData.haber) >= 0.01) {
        formData.debe = 0.00;
        api.post('/polizas/encabezado_polizas/', formData).then((response) => {
            if (poliza === null) {
                response.debe = 0.00;
                response.haber = 0.00;
                dispatch(initializeForm('FormLiquidacionBonos', response));
                dispatch(leerDetalle(response.detalle.encabezado));
            } else {
                const editar = window.location.href.includes('editar');
                if (editar) {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalleMod(poliza));
                } else {
                    response.debe = 0.00;
                    response.haber = 0.00;
                    dispatch(initializeForm('FormLiquidacionBonos', response));
                    dispatch(leerDetalle(poliza));
                }
            }

        }).catch((error) => {
            NotificationManager.error(
                'Ocurrió un error al registrar la poliza',
                'Error',
                2000
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

export const confirmarPoliza = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    NotificationManager.success(
        'Póliza guardada correctamente',
        'Exito',
        3000
    );
    const editar = window.location.href.includes('editar');
    if (editar) {
        ruta = `/compras/${id_emp[5]}/liquidacion_bonos/${id_emp[7]}`;
        dispatch(push(ruta));
    } else {
        window.location.reload(true);
    }
}

const leerDetalleMod = id => (dispatch) => {
    api.get(`/poliza_detalle/${id}`).then((response) => {
        response.polizaDetalle_polizaEncabezado = response
        dispatch({ type: GUARDAR_POLIZA, lectura: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            2000
        );
    })
};

const leerDetalleLiquidacion = id => (dispatch) => {
    api.get(`/liquidacion_bono_detalle/${id}`).then((response) => {
        dispatch({ type: DETALLE_LIQUIDACION, detalleLiq: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

const eliminarDocumento = id => (dispatch) => {
    const liquidacion = obtenerLiquidacion();
    const detalle = liquidacion ? liquidacion.detalleID : null;
                             
    dispatch(setLoader(true));
    api.eliminar(`/liquidacion_gasto_detalle/${id}`).then((response) => {
        if (detalle) {
            const poliza = liquidacion ? liquidacion.idPolizaCompraLiq : null;
            const editar = window.location.href.includes('editar');
            response.fechaRegistro = response.compra.fecha_registro;
            response.numeroL = response.compra.numero;
            response.serie = response.compra.serie;
            response.proveedorN = response.compra.proveedorN;
            response.observaciones = response.compra.descripcion;
            response.identificador = response.compra.nit_proveedor;
            response.totalLiq = response.total;
            response.tipo_documento = response.tipoD;
            response.id = response.compra.id;
            response.combustible = liquidacion ? liquidacion.combustible : null;;
            if (editar) {
                dispatch(leerDetalleLiquidacion(detalle));
                if (response.poliza) {
                    dispatch(leerDetalleMod(poliza));
                }
                dispatch(initializeForm('FormLiquidacionGastos', response));
            } else {
                dispatch(leerDetalleLiquidacion(detalle));
                if (response.poliza) {
                    dispatch(leerDetalle(poliza));
                }
                dispatch(initializeForm('FormLiquidacionGastos', response));
            }
        }
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar el documento',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const imprimirLiquidacion = id => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let idE = id_emp[5];
    let idLiq = id
    let reporte = 'imprimirLiq';
    const params = { idE, reporte, idLiq };
    dispatch(setLoader(true));
    api.getPdf('/liquidacion_gasto', params).then((response) => {
        if (response.headers['content-type'] == 'application/pdf') {
            var blob = new Blob([response.text], { type: 'application/pdf;charset=utf-8' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'reporte_liquidacion_gastos.pdf';
            window.open(link, '_blank');
            return false;
        }
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al generar reporte',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const excelLiquidacion = id => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let idE = id_emp[5];
    let idLiq = id
    let reporte = 'excelLiq';
    const params = { idE, reporte, idLiq };
    dispatch(setLoader(true));
    api.getExcel('/liquidacion_gasto', params).then((response) => {

        const blob = response;
        const fileName = 'Liquidacion_de_gastos.xlsx';

        // Descargar el archivo utilizando la función saveAs de file-saver
        const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(file, fileName);
        
    }).catch((error) => {
        if (error === 404) {
            NotificationManager.error(
              "No se encontraron datos",
              'Informacion',
              5000
            );
          }
          if (error === 500) {
            NotificationManager.error(
              'Ocurrió un error al generar reporte',
              'Error',
              0
            );
          }
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


const eliminarLiquidacion = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`liquidacion_gasto/${id}`).then(() => {
        dispatch(listar(1));
        NotificationManager.success(
            'Liquidacion borrada correctamente',
            'Exito',
            3000
        );
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar liquidacion',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const registroProveedor = (datos) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormLiquidacionGastos.values;
    if (datos.validar_nit === 'S') {
        if (data.identificadorPro === 'cf' || data.identificadorPro === 'CF' || data.identificadorPro === 'c/f' || data.identificadorPro === 'C/F') {
            const formData = {
                identificador: data.identificadorPro,
                nombre: data.nombre,
                direccion: data.direccion,
                telefono: data.telefono,
                correo: data.correo,
                limite: data.limite_credito,
                tipo_proveedor: data.tipo_proveedor,
                dias_credito: data.dias_credito,
                modulo: 'CMP',
                pais: data.pais,
                empresa: id_emp[5]
            }
            dispatch(setLoader(true));
            api.post('/proveedor/', formData).then(() => {
                NotificationManager.success(
                    'Proveedor creado',
                    'Exito',
                    3000
                );

            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    0
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        } else {
            let valid = validar.valNit(data.identificadorPro);
            if (valid === false) {
                Swal.fire({
                    title: 'Proveedor',
                    text: 'Ingrese Nit válido',
                    type: 'error',
                })
            } else {
                const formData = {
                    identificador: data.identificadorPro,
                    nombre: data.nombre,
                    direccion: data.direccion,
                    telefono: data.telefono,
                    correo: data.correo,
                    limite: data.limite_credito,
                    tipo_proveedor: data.tipo_proveedor,
                    dias_credito: data.dias_credito,
                    modulo: 'CMP',
                    pais: data.pais,
                    empresa: id_emp[5]
                }
                dispatch(setLoader(true));
                api.post('/proveedor/', formData).then(() => {
                    NotificationManager.success(
                        'Proveedor creado',
                        'Exito',
                        3000
                    );
                }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        0
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    } else {
        const formData = {
            identificador: data.identificadorPro,
            nombre: data.nombre,
            direccion: data.direccion,
            telefono: data.telefono,
            correo: data.correo,
            limite: data.limite_credito,
            tipo_proveedor: data.tipo_proveedor,
            dias_credito: data.dias_credito,
            modulo: 'CMP',
            pais: data.pais,
            empresa: id_emp[5]
        }
        dispatch(setLoader(true));
        api.post('/proveedor/', formData).then(() => {
            NotificationManager.success(
                'Proveedor creado',
                'Exito',
                2000
            );

        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                0
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

export const buscarFactura = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormBuscarFactura.values;
    if (data === undefined) {
        Swal.fire({
            title: 'Buscar factura',
            text: 'Debe de ingresar datos para buscar factura',
            type: 'error',
        })
    } else {
        if (data.serie === null || data.serie === null) {
            Swal.fire({
                title: 'Buscar factura',
                text: 'Debe de ingresar serie de la factura',
                type: 'error',
            })
        } else {
            if (data.numero === null || data.numero === null) {
                Swal.fire({
                    title: 'Buscar factura',
                    text: 'Debe de ingresar numero de la factura',
                    type: 'error',
                })
            } else {
                const formdata = {
                    empresa: id_emp[5],
                    serie: data.serie,
                    numero: data.numero
                };
                dispatch(setLoader(true));
                api.get('/liquidacion_gasto_detalle/buscar_factura/', formdata).then((response) => {
                    if (response.length >= 1) {
                        dispatch({ type: CONSULTA_FACTURA, factura: response });
                    } else {
                        NotificationManager.error(
                            'No se encontró la factura',
                            'Error',
                            2000
                        );
                    }
                }).catch((error) => {
                    NotificationManager.error(
                        'No se encontró la factura',
                        'Error',
                        2000
                    );
                }).finally(() => {
                    dispatch(setLoader(false));
                });
            }
        }
    }
}

export const leerFactura = (id) => (dispatch) => {
    let params = { id };
    dispatch(setLoader(true));
    api.get('/liquidacion_gasto_detalle/buscar_factura_id/', params).then((response) => {
        dispatch({ type: VER_FACTURA, fact: response });
        dispatch(initializeForm('FormConsultaFactura', response));
        dispatch(leerDetalleMateriales(response.id))
    }).catch((error) => {
        NotificationManager.error(
            'No se encontró la factura',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leerPeriodoD = (id, id_periodo) => (dispatch) => {
    const params = { id, id_periodo };
    api.get('/periodos/periodo', params).then((response) => {
        dispatch({ type: PERIODO_D, periodoD: response.periodo });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar periodo',
            'Error',
            2000
        );
    })
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = { id, modulo }
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response) => {
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const parametrosEmpresa = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id }
    dispatch(setLoader(true));
    api.get('/empresa/empresa_parametros', params).then((response) => {
        dispatch({ type: PARAMETRO, datos: response });
        api.get('/empresa/empresa_impuesto', params).then((imp) => {
            if (imp.validar === 'false') {
                Swal.fire({
                    title: 'Liquidación de gastos',
                    text: imp.msj,
                    type: 'info',
                    allowOutsideClick: false,
                    confirmButtonText: "Continuar",
                }).then((result) => {
                    if (result.value) {
                        let ruta = `/ajustes/${id_emp[5]}/impuestos`
                        dispatch(push(ruta));
                    }
                });
            }
            if (imp.validar === 'true') {
                api.get('/empresa/empresa_configuracion_poliza', params).then((datos) => {
                    if (datos.validar === 'false') {
                        Swal.fire({
                            title: 'Liquidación de gastos',
                            text: datos.msj,
                            type: 'info',
                            allowOutsideClick: false,
                            confirmButtonText: "Continuar",
                        }).then((result) => {
                            if (result.value) {
                                let ruta = `/contabilidad/${id_emp[5]}/config`
                                dispatch(push(ruta));
                            }
                        });
                    }

                }).catch((error) => {

                    NotificationManager.error(
                        'Ocurrió un error al consultar impuesto',
                        'Error',
                        8000
                    );
                })
            }

        }).catch((error) => {

            NotificationManager.error(
                'Ocurrió un error al consultar parametros',
                'Error',
                8000
            );
        })
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar parametros',
            'Error',
            8000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

const listarPaises = () => (dispatch) => {
    return api.get("/paises").then(response => {
        const pais = [];
        response.results.forEach(item => {
            pais.push({
                value: item.id,
                label: item.pais.toUpperCase()
            })
        })
        dispatch({ type: LISTADO_PAISES, listaP: pais });
    }).catch(error => {

        NotificationManager.error(
            'Ocurrió un error al listar paises',
            'Error',
            8000
        );
    })
}

export const listarImpuestos = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5]
    const params = { id };
    dispatch(setLoader(true));
    api.get('/impuesto/impuesto_empresa', params).then((response) => {
        dispatch({ type: LISTADO_IMPUESTO, impuesto: response });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al listar impuesto',
            'Error',
            3000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const listarProyectosGestion = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/orden_servicio/proyectos',params).then(data=>{
        const list_proyectos = [];
        if(data){
            data.forEach(item=>{
                list_proyectos.push({
                    value: item.id,
                    label: item.nombre_proyecto
                })
            })
        }
        return list_proyectos;
    }).catch((error)=>{
        
        return [];
    })
}

export const actions = {
    listar,
    registroCompra,
    modificarCompra,
    leer,
    listarTiposDocu,
    listarProveedores,
    leerDetalle,
    eliminarLinea,
    listarCuentas,
    listarCC,
    listarNiveles,
    registroCuenta,
    reporteCuentas,
    registroPolizaDetalle,
    confirmarPoliza,
    registroPolizaDetalleSCC,
    leerDetalleLiquidacion,
    eliminarDocumento,
    listarProveedoresD,
    imprimirLiquidacion,
    eliminarLiquidacion,
    excelLiquidacion,
    registroProveedor,
    buscarFactura,
    leerFactura,
    leerPeriodoD,
    getModulo,
    parametrosEmpresa,
    listarPaises,
    listarImpuestos,
    listarProyectosGestion,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_COMPRA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [DETALLE_POLIZA]: (state, { detalle }) => {
        return {
            ...state,
            detalle,
        };
    },
    [LISTADO_TIPOS_DOCU]: (state, { tipos }) => {
        return {
            ...state,
            tipos,
        };
    },
    [LISTADO_PROVEEDOR]: (state, { prov }) => {
        return {
            ...state,
            prov,
        };
    },
    [DETALLE_LIQUIDACION]: (state, { detalleLiq }) => {
        return {
            ...state,
            detalleLiq,
        };
    },
    [NIVEL]: (state, { nivel }) => {
        return {
            ...state,
            nivel,
        };
    },
    [LOADERC]: (state, { loaderC }) => {
        return {
            ...state,
            loaderC,
        };
    },
    [GUARDAR_LIQUIDACION]: (state, { lecturaLq }) => {
        return {
            ...state,
            lecturaLq,
        };
    },
    [GUARDAR_POLIZA]: (state, { lectura }) => {
        return {
            ...state,
            lectura,
        };
    },
    [CONSULTA_FACTURA]: (state, { factura }) => {
        return {
            ...state,
            factura,
        };
    },
    [VER_FACTURA]: (state, { fact }) => {
        return {
            ...state,
            fact,
        };
    },
    [PERIODO_D]: (state, { periodoD }) => {
        return {
            ...state,
            periodoD,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [PARAMETRO]: (state, { datos }) => {
        return {
            ...state,
            datos,
        };
    },
    [LISTADO_PAISES]: (state, { listaP }) => {
        return {
            ...state,
            listaP,
        };
    },
    [LISTADO_IMPUESTO]: (state, { impuesto }) => {
        return {
            ...state,
            impuesto,
        };
    },
    [PROVEEDOR]: (state, { proveedor_liq }) => {
        return {
            ...state,
            proveedor_liq,
        };
    },
    [TOTAL_LIQ]: (state, { total_liq }) => {
        return {
            ...state,
            total_liq,
        };
    },
};

export const initialState = {
    loader: false,
    tipos: [],
    prov: [],
    factura: [],
    fact: [],
    nivel: [],
    encabezado: [],
    periodoD: [],
    impuesto: [],
    modulo: [],
    loaderC: false,
    detalle: [],
    datos: [],
    listaP: [],
    detalleLiq: [],
    data: [],
    page: 1,
    lectura: [],
    lecturaLq: [],
    proveedor_liq: '',
    total_liq: 0.00
};

export default handleActions(reducers, initialState)